import { Injectable, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorPopupComponent } from './@shared/error-popup/error-popup.component';

@Injectable({
  providedIn: 'root',
})
export class GlobalEventsService {
  onPromotToAcceptTerms = new EventEmitter<void>();
  onLoadCompanyPlan = new EventEmitter<void>();
  onQuickActionResolved = new EventEmitter<void>();

  constructor(private dialog: MatDialog) {}

  onUnauthorizedException() {
    this.dialog.open(ErrorPopupComponent, {
      width: '560px',
      maxWidth: 'calc(100vw - 32px)',
      autoFocus: false,
      data: { error: 'error_popup_message' },
    });
  }
}
